module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "als"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_c('b', [_vm._v("OTHER BOOKS BY STUDS TERKEL")])]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("American Dreams "), _c('br'), _c('i', [_vm._v("Lost and Found")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("Division Street "), _c('br'), _c('i', [_vm._v("America")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("Giants of Jazz")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("Hard Times "), _c('br'), _c('i', [_vm._v("An Oral History of the Great Depression")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("Hope Dies Last "), _c('br'), _c('i', [_vm._v("Keeping the Faith in Troubled Times")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("My American Century")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("The Spectator "), _c('br'), _c('i', [_vm._v("Talk About Movies and Plays with the People Who Make Them")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("Talking to Myself "), _c('br'), _c('i', [_vm._v("A Memoir of My Times")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("Will the Circle Be Unbroken? "), _c('br'), _c('i', [_vm._v("Reflections on Death, Rebirth, and Hunger for a Faith")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("Working "), _c('br'), _c('i', [_vm._v("People Talk About What They Do All Day and")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("How They Feel About What They Do")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33eb8e5d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stud_9781595587596_oeb_als_r1.vue
// module id = 63
// module chunks = 0